let timeout: NodeJS.Timeout;

/**
 * This is a very basic throttle implementation.
 */
export function throttle(callback: () => void, ms = 500) {
  clearTimeout(timeout);
  timeout = setTimeout(() => callback(), ms);
}
